import AboutYou from "./AboutYou";
import TopNavBar from "../../Shared/TopNavBar";
import Breadcrumbs from "../../Shared/Breadcrumbs";
import RegularBanner from "../../MainSite/SHARED/RegularBanner";
import CTAButton from "../../MainSite/SHARED/CTAButton";
import TopNavBlank from "../../Shared/TopNavBlank";
import { useFormik } from "formik";
import * as Yup from "yup";

const StepTwo = () => {
  const validationSchema = Yup.object().shape({
    iConfirm: Yup.boolean()
      .oneOf(
        [true],
        "You must confirm that you have read and understood the important information above"
      )
      .required(
        "You must confirm that you have read and understood the important information above"
      ),
  });

  const formik = useFormik({
    initialValues: {
      iConfirm: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  return (
    <div className="container-fluid mb-5 blueBorderBott oh">
      <TopNavBlank theme={"white"} />
      <RegularBanner
        headlineLine1={"Your bike "}
        headlineLine2={"insurance quote"}
        subheadlineLine1={"Tell us about you, your bike and cover you need."}
        subheadlineLine2={""}
        hasCTA={"false"}
        CTAText={"Get a quote"}
      />

      <Breadcrumbs currentPage="yourDetails" />

      <AboutYou />
    </div>
  );
};

export default StepTwo;
